const SVG_ATTR = "svg-inline";

async function inlineImage(img) {
    if (!img || img.dataset.svgInlineReady === "1") return;

    const src = img.currentSrc || img.src || img.getAttribute("src");
    if (!src || (!/\.svg(?:$|[?#])/i.test(src) && !src.startsWith("data:image/svg+xml"))) return;

    img.dataset.svgInlineReady = "1";

    try {
        const text = await readSvgText(src);
        const doc = new DOMParser().parseFromString(text, "image/svg+xml");
        const svg = doc.documentElement;

        if (!svg || svg.nodeName.toLowerCase() !== "svg") {
            img.dataset.svgInlineReady = "";
            return;
        }

        for (const attr of Array.from(img.attributes)) {
            if (attr.name === SVG_ATTR || attr.name === "src") continue;
            svg.setAttribute(attr.name, attr.value);
        }

        svg.removeAttribute("xmlns:a");
        svg.setAttribute("aria-hidden", img.getAttribute("alt") ? "false" : "true");
        img.replaceWith(document.importNode(svg, true));
    } catch (error) {
        img.dataset.svgInlineReady = "";
    }
}

async function readSvgText(src) {
    if (src.startsWith("data:image/svg+xml")) {
        const payload = src.replace(/^data:image\/svg\+xml[^,]*,/, "");
        return decodeURIComponent(payload);
    }

    if (typeof fetch !== "function") {
        throw new Error("SVG fetch is not available");
    }

    const response = await fetch(src);
    return response.text();
}

function inlineSvgImages(root = document) {
    if (typeof document === "undefined") return;
    root.querySelectorAll?.(`img[${SVG_ATTR}]`)?.forEach((img) => {
        inlineImage(img);
    });
}

export function installInlineSvgRuntime(router) {
    if (typeof document === "undefined") return;

    const run = () => {
        requestAnimationFrame(() => inlineSvgImages(document));
    };

    run();
    router?.afterEach?.(run);

    const observer = new MutationObserver(run);
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}
